<template>
  <div class="login-page">
    <div class="login-page__glow login-page__glow--one"></div>
    <div class="login-page__glow login-page__glow--two"></div>

    <section class="login-panel" aria-labelledby="login-title">
      <div class="login-panel__intro">
        <router-link class="login-brand" to="/" aria-label="返回尚亚信息首页">
          <img :src="defaultLogo" alt="尚亚信息" />
        </router-link>
        <span class="login-eyebrow">SITE MANAGEMENT</span>
        <h1 id="login-title">网站内容管理中心</h1>
        <p>统一维护官网配置、案例、团队、合作伙伴及数据字典，让内容发布更高效。</p>
        <ul>
          <li><i class="el-icon-check" aria-hidden="true"></i> 集中管理网站内容</li>
          <li><i class="el-icon-check" aria-hidden="true"></i> 安全的会话认证</li>
          <li><i class="el-icon-check" aria-hidden="true"></i> 桌面与移动端均可访问</li>
        </ul>
      </div>

      <div class="login-panel__form-wrap">
        <div class="login-form-heading">
          <span>ADMIN LOGIN</span>
          <h2>欢迎回来</h2>
          <p>请输入管理员账号信息继续。</p>
        </div>

        <el-form
          class="login-form"
          ref="lform"
          :model="loginform"
          :rules="rules"
          label-position="top"
          @submit.native.prevent="login"
        >
          <el-form-item label="用户名" prop="name">
            <el-input
              name="username"
              v-model.trim="loginform.name"
              autocomplete="username"
              prefix-icon="el-icon-user"
              placeholder="请输入用户名"
              @keyup.enter.native="focusPassword"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pass">
            <el-input
              ref="passwordInput"
              name="password"
              type="password"
              v-model="loginform.pass"
              autocomplete="current-password"
              prefix-icon="el-icon-lock"
              placeholder="请输入密码"
              show-password
              @keyup.enter.native="login"
            ></el-input>
          </el-form-item>
          <el-button
            class="login-submit"
            type="primary"
            native-type="submit"
            :loading="submitting"
            @click="login"
          >
            {{ submitting ? "正在登录" : "登录管理后台" }}
          </el-button>
        </el-form>

        <router-link class="back-home" to="/">
          <span aria-hidden="true">←</span>
          返回网站首页
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import defaultLogo from "../assets/img/shangya-logo.png";

export default {
  data() {
    return {
      defaultLogo,
      submitting: false,
      loginform: {
        name: "",
        pass: ""
      },
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        pass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 5,
            max: 20,
            message: "密码长度在 5 到 20 个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    focusPassword() {
      if (this.$refs.passwordInput) {
        this.$refs.passwordInput.focus();
      }
    },
    login() {
      if (this.submitting) return;

      this.$refs.lform.validate(valid => {
        if (!valid) {
          this.$message({ message: "请完整填写登录信息", type: "warning" });
          return;
        }

        this.submitting = true;
        const user = encodeURIComponent(this.loginform.name);
        const password = encodeURIComponent(this.loginform.pass);

        fetch(`/api/admin/login?name=${user}&pass=${password}`, {
          credentials: "same-origin"
        })
          .then(response => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.json();
          })
          .then(data => {
            if (!data.bRes) {
              throw new Error(data.message || "账号或密码错误");
            }

            sessionStorage.setItem("token", data.Ticket);
            this.$message({ message: "登录成功", type: "success" });
            const redirect = this.$route.query.redirect;
            const target = typeof redirect === "string" && redirect.indexOf("/admin") === 0
              ? redirect
              : "/admin/site-config";
            this.$router.push(target);
          })
          .catch(error => {
            this.$message({
              message: error.message || "登录服务暂时不可用，请稍后重试",
              type: "error"
            });
          })
          .then(() => {
            this.submitting = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-page {
  position: relative;
  display: grid;
  place-items: center;
  min-height: calc(100vh - 72px);
  padding: clamp(32px, 6vw, 72px) var(--page-gutter);
  overflow: hidden;
  background:
    linear-gradient(135deg, rgba(7, 35, 57, 0.97), rgba(10, 69, 108, 0.95)),
    url("../assets/img/bgtop.jpg") center / cover;
}

.login-page__glow {
  position: absolute;
  width: 360px;
  height: 360px;
  border-radius: 50%;
  filter: blur(16px);
  opacity: 0.28;
  pointer-events: none;
}

.login-page__glow--one {
  top: -160px;
  right: 8%;
  background: #4bc7ff;
}

.login-page__glow--two {
  bottom: -200px;
  left: 3%;
  background: #5bd9b2;
}

.login-panel {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(360px, 0.75fr);
  width: min(100%, 1080px);
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.48);
  border-radius: 28px;
  box-shadow: 0 32px 90px rgba(0, 18, 33, 0.35);
}

.login-panel__intro,
.login-panel__form-wrap {
  padding: clamp(40px, 6vw, 76px);
}

.login-panel__intro {
  position: relative;
  color: #fff;
  background:
    linear-gradient(145deg, rgba(11, 77, 119, 0.96), rgba(7, 45, 72, 0.98)),
    url("../assets/img/home_do.jpg") center / cover;

  &::after {
    content: "";
    position: absolute;
    right: -80px;
    bottom: -100px;
    width: 260px;
    height: 260px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 50%;
  }

  h1 {
    position: relative;
    z-index: 1;
    margin: 18px 0;
    font-size: clamp(34px, 4vw, 52px);
    line-height: 1.15;
    letter-spacing: -0.04em;
  }

  > p {
    position: relative;
    z-index: 1;
    max-width: 520px;
    margin: 0;
    color: rgba(255, 255, 255, 0.76);
    line-height: 1.9;
  }

  ul {
    position: relative;
    z-index: 1;
    display: grid;
    gap: 14px;
    margin: 34px 0 0;
    padding: 0;
    list-style: none;
  }

  li {
    display: flex;
    align-items: center;
    gap: 12px;
    color: rgba(255, 255, 255, 0.88);
  }

  li i {
    display: grid;
    place-items: center;
    width: 24px;
    height: 24px;
    color: #0c699e;
    background: #fff;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 800;
  }
}

.login-brand {
  position: relative;
  z-index: 1;
  display: inline-flex;
  padding: 10px 14px;
  margin-bottom: 48px;
  background: #fff;
  border-radius: 10px;

  img {
    width: 146px;
    height: auto;
  }
}

.login-eyebrow,
.login-form-heading > span {
  position: relative;
  z-index: 1;
  color: #66d5ff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.22em;
}

.login-panel__form-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.login-form-heading {
  margin-bottom: 30px;

  > span {
    color: var(--color-brand);
  }

  h2 {
    margin: 12px 0 8px;
    color: var(--color-ink);
    font-size: clamp(28px, 3vw, 38px);
  }

  p {
    margin: 0;
    color: var(--color-ink-muted);
  }
}

.login-form {
  ::v-deep .el-form-item {
    margin-bottom: 22px;
  }

  ::v-deep .el-form-item__label {
    padding-bottom: 8px;
    color: var(--color-ink);
    font-weight: 700;
    line-height: 1.4;
  }

  ::v-deep .el-input__inner {
    height: 50px;
    padding-left: 42px;
  }
}

.login-submit {
  width: 100%;
  min-height: 50px;
  margin-top: 6px;
  font-size: 15px;
  font-weight: 700;
}

.back-home {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 8px;
  margin-top: 24px;
  color: var(--color-ink-muted);
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    color: var(--color-brand);
  }
}

@media (max-width: 860px) {
  .login-page {
    min-height: calc(100vh - 56px);
    padding: 24px 16px 40px;
  }

  .login-panel {
    grid-template-columns: 1fr;
    border-radius: 20px;
  }

  .login-panel__intro {
    padding: 34px 28px;

    > p,
    ul {
      display: none;
    }

    h1 {
      margin-bottom: 0;
      font-size: 30px;
    }
  }

  .login-brand {
    margin-bottom: 30px;
  }

  .login-panel__form-wrap {
    padding: 36px 28px 40px;
  }
}

@media (max-width: 420px) {
  .login-panel__intro,
  .login-panel__form-wrap {
    padding-right: 22px;
    padding-left: 22px;
  }
}
</style>
